module.exports = function anonymous(it
/**/) {
var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (function (doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	}());var out='<div class="cols-l-6 cols-xxl-3 "> <div class="fragment fragment--style01 equal"> <a href="'+encodeHTML(it.Url)+'" class="fragment__row"> <div class="fragment__cell"> <div class="fragment__content"> <div class="fragment-rte"> <h2 class="title-02">'+encodeHTML(it.Role)+'</h2> </div> </div> </div> </a> <div class="fragment__row"> <div class="fragment__cell"> <a href="'+encodeHTML(it.Url)+'" class="fragment__image fragment__image--full"><img src="'+encodeHTML(it.Thumb)+'" alt="'+encodeHTML(it.JourneyText)+'"></a> </div> </div> <div class="fragment__row"> <div class="fragment__cell"> <ul class="fragment__ctas"> <li><a href="'+encodeHTML(it.Url)+'" class="cta cta--arrow-right">'+encodeHTML(it.JourneyText)+'</a></li> </ul> </div> </div> </div></div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/templates/filters/careers.dot
 ** module id = 249
 ** module chunks = 0 1
 **/